/* Progressive enhancement only. Pricing, request submission and configurator state are deliberately untouched. */
(() => {
  'use strict';
  const initialize = root => {
    if (!root || root.dataset.fpmReady) return;
    root.dataset.fpmReady = 'true';
    root.querySelectorAll('[data-fpm-models]').forEach(section => {
      const bar = section.querySelector('[data-fpm-filterbar]');
      const cards = [...section.querySelectorAll('[data-fpm-model]')];
      const status = section.querySelector('[data-fpm-filter-status]');
      if (!bar || !cards.length) return;
      bar.hidden = false;
      bar.addEventListener('click', event => {
        const button = event.target.closest('[data-fpm-filter]');
        if (!button || !bar.contains(button)) return;
        const filter = button.dataset.fpmFilter;
        let shown = 0;
        cards.forEach(card => {card.hidden = filter !== 'all' && card.dataset.fpmModel !== filter; if (!card.hidden) shown++;});
        bar.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        if (status) {const local = shown === 1 ? status.dataset.fpmCountOne : status.dataset.fpmCountMany; status.textContent = local ? local.replace('{count}', String(shown)).replace('{label}', button.textContent.trim()) : `${shown} ${shown === 1 ? 'model' : 'models'} shown: ${button.textContent.trim()}.`;}
      });
    });
    root.querySelectorAll('[data-fpm-product]').forEach(product => {
      const main = product.querySelector('[data-fpm-gallery-main] img');
      const thumbs = product.querySelector('[data-fpm-gallery-thumbs]');
      const status = product.querySelector('[data-fpm-gallery-status]');
      if (!main || !thumbs || !thumbs.children.length) return;
      thumbs.hidden = false;

      const stage = main.parentElement;
      let request = 0;
      let fade = null;
      let outgoing = null;
      const loaded = new Map();
      const loadPhoto = src => {
        if (!loaded.has(src)) {
          const photo = new Image();
          photo.src = src;
          loaded.set(src, photo.decode().then(() => photo).catch(error => { loaded.delete(src); throw error; }));
        }
        return loaded.get(src);
      };
      const showPhoto = async (src, alt, selected) => {
        const serial = ++request;
        try {
          const photo = await loadPhoto(src);
          if (serial !== request) return;
          if (fade) fade.cancel();
          if (outgoing) outgoing.remove();
          const previous = main.cloneNode(false);
          previous.removeAttribute('id');
          previous.alt = '';
          previous.setAttribute('aria-hidden', 'true');
          previous.classList.add('fp-gallery-outgoing');
          stage.append(previous);
          outgoing = previous;
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.width = photo.naturalWidth;
          main.height = photo.naturalHeight;
          main.src = photo.src;
          main.alt = alt;
          selected();
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !previous.animate) {
            previous.remove();
          } else {
            fade = previous.animate([{opacity:1},{opacity:0}],{duration:220,easing:'ease-out',fill:'forwards'});
            fade.finished.then(() => previous.remove()).catch(() => previous.remove());
          }
        } catch (_) {
          if (serial === request && status) status.textContent = status.dataset.error || '';
        }
      };

      const buttons = [...thumbs.querySelectorAll('[data-fpm-photo]')];
      const prefetchNext = index => {
        [index - 1,index + 1].forEach(n => {
          const button = buttons[(n + buttons.length) % buttons.length];
          if (button) loadPhoto(button.dataset.fpmPhoto).catch(() => {});
        });
      };
      const select = button => {
        showPhoto(button.dataset.fpmPhoto, button.dataset.fpmAlt || '', () => {
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          if (status) status.textContent = '';
          prefetchNext(buttons.indexOf(button));
        });
      };
      thumbs.addEventListener('click', event => {
        const button = event.target.closest('[data-fpm-photo]');
        if (button && thumbs.contains(button)) select(button);
      });
      thumbs.addEventListener('pointerover', event => {
        const button = event.target.closest('[data-fpm-photo]');
        if (button) loadPhoto(button.dataset.fpmPhoto).catch(() => {});
      });
      thumbs.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const current = buttons.indexOf(event.target.closest('button'));
        const button = buttons[(current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length];
        button.focus();
        select(button);
      });
      prefetchNext(0);
    });
    root.querySelectorAll('[data-fpm-video-toggle]').forEach(button => {
      const video = [...root.querySelectorAll('[data-fpm-video]')].find(item => item.dataset.fpmVideo === button.dataset.fpmVideoToggle);
      if (!video) return;
      const label = button.querySelector('[data-fpm-video-label]');
      const initialLabel = label?.textContent || 'Play film';
      let loading = false;
      button.hidden = false;
      const sync = () => {const playing = !video.paused && !video.ended; button.setAttribute('aria-pressed', String(playing)); if (label) label.textContent = playing ? (button.dataset.pause || 'Pause film') : initialLabel;};
      button.addEventListener('click', async () => {
        if (loading) return;
        if (!video.paused) {video.pause(); return;}
        loading = true;
        try {
          if (!video.getAttribute('src')) {
            video.src = window.matchMedia('(max-width:700px)').matches && video.dataset.smallSrc ? video.dataset.smallSrc : video.dataset.src;
            if (video.dataset.fpmVideo !== 'hero') video.controls = true;
          }
          await video.play();
        } catch (_) {
          if (label) label.textContent = button.dataset.error || 'Film unavailable — try again';
          button.setAttribute('aria-pressed','false');
        } finally {loading = false;}
      });
      ['play','pause','ended'].forEach(name => video.addEventListener(name,sync));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {entries.forEach(entry => {if (!entry.isIntersecting && !video.paused) video.pause();});}, {threshold:0.05});
        observer.observe(video);
      }
      window.addEventListener('pagehide', () => video.pause());
    });
  };
  const start = () => document.querySelectorAll('[data-fpm-site]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fpm-site]').forEach(initialize));
})();


